import React from 'react'

export default function WizardFooter({ children }) {
  return <div className="new-app-form-footer">{children}</div>
}
